export default __webpack_public_path__ + "static/media/4.ae66a8d1.png";